/**
 * The Store for the App
 */

import { writable, derived } from 'svelte/store';
import { loginBannerMap } from './constants';

export const store = writable({
    isUserSignedIn: false,
    itslearningLoginUrl: '',
    ssoInfos: [], // Array of sitename and ssoUri
    ssoDisabled: false,
    isInitialised: false,
    isLoading: false,
    isLoadCompleted: false,
    isRedirecting: false,
    noConnectedAccount: false,
    multipleAccounts: false,
    // errorMessageSso: '',
    googleUser: {},
    i18n: {},
    ssoLoginSources: {
        chromebook: '',
        gSuite: '',
        browser: '',
        googleCalendar: '',
        chromeBrowserExtension: '',
    },
    ssoLoginSource: '',
    settings: {
        platformRestApiStartUrlSsl: '',
        chromebookExtensionId: '',
        gSuiteMarketplaceAppReferrer: '',
        itslearningLocationTypes: [],
        itslearningLoginUrl: '',
        chromeBrowserExtensionAppStoreId: ''
    },
    redirectLocationType: '',
    redirectData: '',
    clientId: '',
    errorCode: undefined
});

export const loginBanner = derived(store, $store => loginBannerMap[$store.errorCode]);

export function getStoreValue(s) {
    if (!s) {
        s = store;
    }

    let _store;

    const unsubscribe = s.subscribe(value => {
        _store = value;
    });

    unsubscribe();

    return _store;
}

export function updateStoreValue(changes) {
    store.update(value => ({
        ...value,
        ...changes
    }));
}
